/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  HttpLink,
} from '@apollo/client/core';

interface ClientConfig {
  uri: string
}

export type ApolloClientCustom = ApolloClient<NormalizedCacheObject>;

// eslint-disable-next-line max-len
export default function createGraphQlClient({ uri }: ClientConfig): ApolloClientCustom {
  const httpLink = new HttpLink({ uri, fetch });
  return new ApolloClient<NormalizedCacheObject>({
    uri,
    cache: new InMemoryCache({ addTypename: false }),
    link: httpLink,
  });
}
